/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: System
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 13Dec2022 craig File created.
 \******************************************************************************/
import React, {Fragment, useMemo, useState} from "react";
import {useRequest} from "../../../helper/useRequest";
import {ISystemUrl} from "../../../models/admin/ISystem";
import {Button, Col, Container, Image, Row} from "react-bootstrap";
import {ITeam} from "../../../models/application/IApplication";
import {TeamUsersTable} from "../../../components/TeamUsersTable";

export const System: React.FC = () => {
    const [systemLinks, setSystemLinks] = useState<ISystemUrl[]>([]);
    const systemURL = process.env.REACT_APP_API_URL + "/api/admin/system/links";

    const [requestState, getSystemData] = useRequest({url: systemURL, initialIsLoading: true,});
    const {isLoading, data, error} = requestState;

    useMemo(() => {
        getSystemData();
    }, [])

    useMemo(() => {
        if (data != null) {
            setSystemLinks(data);
        }
    },[data])

    const buildSystemLinks = () => {
        return (
            <Container fluid>
                {systemLinks?.map((systemLink: ISystemUrl) => (
                    <Container>
                        <Row id={systemLink.Label}>
                            <a href={systemLink.Url} rel={"noreferrer"}>{systemLink.Label}</a>
                        </Row>
                    </Container>
                ))}
            </Container>
        )
    }


    return (
        <Fragment>
            {isLoading && <p>Loading ...</p>}
            {error && <p>Error</p>}
            {data && buildSystemLinks()}
        </Fragment>
    );


}